import script from "./foldersManager.vue?vue&type=script&lang=js"
export * from "./foldersManager.vue?vue&type=script&lang=js"

import "./foldersManager.vue?vue&type=style&index=0&id=2cf6ef48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf6ef48"]])

export default __exports__